<template>
  <div>
    <smart-table ref="smartTable"
                 :headers="headers()"
                 :search-function="searchFunction"
                 preference-key="LocalUnit">

      <!-- smart table slot HEADER-ITEM-1: new dialog (activate in the headers) -->
      <template v-slot:HEADER-ITEM-1>
        <v-btn @click="openDialog()" color="main" class="white--text" small depressed :style="{ visibility: canReadOnly ? 'hidden' : 'visible' }">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          {{ translations.newButton }}
        </v-btn>
      </template>

      <!-- smart table slot results -->
      <template v-slot:results="{ item: item }">
        <!-- name -->
        <td>
          {{ item.name }}
        </td>

        <!-- description -->
        <td>
          {{ item.description }}
        </td>

        <!-- actions -->
        <td width="100">
          <div class="d-flex justify-space-around">
            <!-- edit -->
            <v-icon v-if="!item.loading" @click="openDialog(item)" small class="cursor-pointer" :style="{ visibility: canReadOnly ? 'hidden' : 'visible' }">
              mdi-square-edit-outline
            </v-icon>

            <!-- delete -->
            <v-icon v-if="!item.loading" @click="deleteConfirmation(item)" small color="error lighten-1" class="cursor-pointer" :style="{ visibility: canReadOnly ? 'hidden' : 'visible' }">
              mdi-delete-outline
            </v-icon>
          </div>
        </td>
      </template>
    </smart-table>

    <!-- dialog -->
    <local-unit-save-edit-dialog :item="selectedItem" :show="showDialog" :update="isUpdate"
                                 @closeDialog="closeDialog()"
                                 @updated="$refs.smartTable.getTableRows()" />
  </div>
</template>


<script>
import { translations } from '@/utils/common'

import LocalUnitService from '@/service/localUnit/LocalUnitService'

import SmartTable from '@/components/SmartTable'
import LocalUnitSaveEditDialog from '@/views/LocalUnit/LocalUnitSaveEditDialog'
import { mapState } from "vuex";

export default {
  name: 'LocalUnit',

  components: {
    SmartTable,
    LocalUnitSaveEditDialog
  },

  data() {
    return {
      translations: translations,

      showDialog: false,
      isUpdate: false,
      selectedItem: {}
    }
  },

  methods: {
    headers() {
      const headers = []

      headers.push({
        type: 'TEXT',
        name: 'name',
        label: translations.name,
        sort: 'name'
      })

      headers.push({
        type: 'TEXT',
        name: 'description',
        label: translations.description,
        sort: 'description'
      })

      // actions
      headers.push({
        type: 'HEADER-ITEM-1'
      })

      return headers
    },

    searchFunction(params) {
      return LocalUnitService.search(params)
    },

    openDialog(item) {
      this.showDialog = true
      this.isUpdate = !!item
      this.selectedItem = item ? item : {}
    },

    closeDialog() {
      this.showDialog = false
      this.selectedItem = {}
      this.isUpdate = false
    },

    deleteConfirmation(item) {
      if (confirm(translations.areYouSure)) {
        this.deleteItem(item)
      }
    },

    async deleteItem(item) {
      item.loading = true
      await LocalUnitService.delete({
          localUnitId: item.id
        })
        .then(() => {
          this.$root.vtoast.show({ message: translations.deletedSuccess })
          this.$refs.smartTable.getTableRows()
        })
        .catch(() => {
          this.$root.vtoast.showError({ message: translations.deletedFailed })
        })
        .finally(() => {
          item.loading = false
        })
    }
  },

  computed: {
    ...mapState({
      canReadOnly: state => state.auth.userInfo.account?.capabilities.some(c => c.name === 'Read-only')
    })
  }
}
</script>
